<template>
	<polar-area :data="data" :options="options" />
</template>

<script>
import { PolarArea } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

const PolarChart = {
	props: ['data', 'options'],
	components: { PolarArea }
}

export default PolarChart
export { PolarChart as mdbPolarChart }
</script>
